import React from 'react';
import { Users, Zap, Shield, Globe } from 'lucide-react'; // ✅ Import icons

const WhyPartner = () => {
  // Benefits data
  const benefits = [
    {
      icon: <Users className="w-8 h-8" />,
      title: 'DGCA RECOGNISED CREDIBILITY',
      description:
        'Aerobott is a DGCA recognised Remote Pilot Training Organisation. Partnering with us gives your institute or business the credibility and regulatory backing of working with a certified drone company.',
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: 'END TO END SUPPORT',
      description:
        'From onboarding and training to technical support and co-marketing — Aerobott provides complete partner support so you can launch and scale your drone program without building everything from scratch.',
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: 'PROVEN PRODUCTS AND PROGRAMS',
      description:
        'Our drone products and training programs are battle-tested across hundreds of students and multiple industries. Partners get access to curriculum, hardware, and operational systems that work.',
    },
    {
      icon: <Globe className="w-8 h-8" />,
      title: 'GROWING NETWORK ACROSS INDIA',
      description:
        "As a partner you join a growing network of institutes, businesses, and operators deploying Aerobott's technology and training across India — with access to joint opportunities, referrals, and collaborative projects.",
    },
  ];

  return (
    <section className="py-20 px-4 bg-black/40">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-raleway font-medium mb-6 bg-gradient-to-r from-white to-white bg-clip-text text-transparent">
            Why Partner with Aerobott?
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto font-raleway leading-relaxed">
            Aerobott brings manufacturing capability, DGCA certification, trained pilots, and operational expertise to every partnership. Here is what you get when you partner with us.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="group h-full">
              <div className="h-full flex flex-col bg-black/40 hover:bg-gray-800/50 p-8 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl border border-gray-800 hover:border-purple-400 backdrop-blur-sm">
                <div className="text-purple-400 mb-4 group-hover:text-purple-300 transition-colors duration-300">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-raleway font-medium mb-3 text-white group-hover:text-purple-200 transition-colors duration-300">
                  {benefit.title}
                </h3>
                <p className="text-gray-300 group-hover:text-gray-200 transition-colors duration-300 font-raleway leading-relaxed flex-grow">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyPartner;
